<template>
	<div class="vote-ui">
		<Action class="vote-ui__action" @click="dislike">
			<IconDislike title="Dislike" />
		</Action>
		<p class="vote-ui__prompt vote-ui__prompt--touch">Swipe to vote!</p>
		<p class="vote-ui__prompt vote-ui__prompt--mouse">
			Drag left or right to vote!
		</p>
		<Action class="vote-ui__action" @click="like">
			<IconLike title="Like" />
		</Action>
	</div>
</template>

<script>
import IconLike from 'mdi-vue/ThumbUp'
import IconDislike from 'mdi-vue/ThumbDown'
import Action from '@/components/shared/Action'

export default {
	name: 'VoteUI',
	methods: {
		like() {
			this.$emit('vote', true)
		},
		dislike() {
			this.$emit('vote', false)
		}
	},
	components: {
		IconLike,
		IconDislike,
		Action
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.vote-ui {
	@extend %flex-center;
	background-color: $blue-73;
	height: 5rem;
	padding: 0 1.5rem;

	&__action,
	&__prompt {
		color: $white;
	}

	&__action {
		@include circle-button(1.5rem, $blue-48, $blue-30);
	}

	&__prompt {
		flex-grow: 1;
		text-align: center;
		margin: 0 1.5rem;
		font-weight: bold;
		max-width: 16rem;

		// Change prompt based on touch vs mouse input
		&--mouse {
			display: none;
		}

		@media (hover: hover) {
			&--mouse {
				display: block;
			}
			&--touch {
				display: none;
			}
		}
	}
}
</style>
